import { ReactNode } from 'react';
import {
  ChevronDownIcon,
  ChevronUpIcon,
} from '@pmi/dsm-react/dist/components/icons/fa/16';
import './style.scss';

export interface DropDownMenuProps {
  menuClassName?: string;
  children: ReactNode;
  showMenu: boolean;
  menuRef: any;
  hideIcon?: boolean;
}

export default function DropDownMenu({
  menuClassName = '',
  children,
  showMenu,
  menuRef,
  hideIcon = false,
}: DropDownMenuProps) {
  return (
    <div
      className={`d-flex flex-wrap align-content-center position-${
        hideIcon ? 'absolute' : 'relative'
      }`}
    >
      <div className="cursor-pointer text-primary dropdown-menu-icon">
        {!hideIcon && (
          <>
            {!showMenu && <ChevronDownIcon />}
            {showMenu && <ChevronUpIcon />}
          </>
        )}
      </div>

      {showMenu && (
        <div
          ref={menuRef}
          className={`position-absolute end-0 top-100 ${menuClassName}`}
          style={{ zIndex: '100' }}
        >
          {children}
        </div>
      )}
    </div>
  );
}
